module.exports = __webpack_public_path__ + "static/media/icon - SOS Bell Enabled.c0557e5f.svg";